import React from 'react';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import { MutedBackground, LightBackground } from 'scy/Background';
import ValueProps from 'scy/ValueProps';
import MediaLogos from 'scy/MediaLogos';
import Footer from 'components/footer';
import { borderBox } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';
import { config } from 'components/home/landingPage';

export default function AuthPageContainer({
  children,
  renderNav,
  renderFooter
}) {
  return (
    <MutedBackground className={borderBox}>
      <div className={styles.header}>
        <a href="/" className={styles.logo}>
          <WordmarkIcon width={120} />
        </a>

        {!!renderNav && renderNav()}
      </div>

      <div className={styles.container}>
        <LightBackground className={styles.formBackground}>
          <div className={styles.formContainer}>{children}</div>
        </LightBackground>

        {!!renderFooter && renderFooter()}

        <ValueProps title={'How to get Saucey'} listItems={config} />
        <MediaLogos />
      </div>

      <Footer />
    </MutedBackground>
  );
}
